import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import PageMainHeader from '../../../../common/pages/PageMainHeader/PageMainHeader.component';
import PageMainBody from '../../../../common/pages/PageMainBody/PageMainBody.component';

import ProgressBar from '../ProgressBar/ProgressBar.component';
import FacebookConnection from '../steps/FacebookConnection/FacebookConnection.component';
import QRCodeConnection from '../steps/QRCodeConnection/QRCodeConnection.component';
import ChannelConfiguration from '../steps/ChannelConfiguration/ChannelConfiguration.component';

const ChannelAddWaba = () => {
  const history = useHistory();
  const currentCustomer = useSelector(
    (state) => state?.general?.current_customer_id
  );
  
  // Pegar state enviado pela URL
  const { state: historyState } = history.location;
  
  const [currentStep, setCurrentStep] = useState(1);
  const [hasError, setHasError] = useState(false);
  const [channelData, setChannelData] = useState({
    wabaId: null,
    phoneNumberId: null,
    accessToken: null,
    phoneNumber: null,
    displayName: null,
    connectionStatus: 'connected' // Already connected via coexistence flow
  });

  useEffect(() => {
    /**
     * verifica se a empresa passou pela analise do plano antes de criar canal
     */
    if (!historyState?.validated_can_add_channel) {
      history.push(`/tools/channels/add`);
      return;
    }
  }, []);

  const handleStepComplete = (stepData) => {
    setChannelData(prev => ({ ...prev, ...stepData }));
    setCurrentStep(prev => prev + 1);
  };

  const handleStepBack = () => {
    setCurrentStep(prev => Math.max(1, prev - 1));
    setHasError(false); // Reset error when going back
  };

  const handleError = (errorMessage) => {
    setHasError(true);
    if (errorMessage) {
      toast.error(errorMessage);
    }
    
    // After 3 seconds, offer to redirect back to channels list
    setTimeout(() => {
      const shouldRedirect = window.confirm(
        'Deseja voltar para a lista de canais? Clique em OK para voltar ou Cancelar para tentar novamente.'
      );
      
      if (shouldRedirect) {
        history.push('/tools/channels/list');
      } else {
        setHasError(false);
        // Reset to first step to allow user to try again
        setCurrentStep(1);
      }
    }, 3000);
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <FacebookConnection
            onComplete={handleStepComplete}
            onError={handleError}
            customerId={currentCustomer}
          />
        );
      case 2:
        return (
          <ChannelConfiguration
            onComplete={() => {
              toast.success('Canal configurado com sucesso!');
              history.push('/tools/channels/list');
            }}
            onBack={handleStepBack}
            onError={handleError}
            channelData={channelData}
            customerId={currentCustomer}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <PageMainHeader 
        title="Conectar WhatsApp Business API"
        icon="poli-icon pi-whatsapp-business-fill"
        iconSize="30"
      />
      <PageMainBody>
        <ProgressBar currentStep={currentStep} totalSteps={2} />
        {renderCurrentStep()}
      </PageMainBody>
    </>
  );
};

export default ChannelAddWaba;
